var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-general-layout"},[_c('div',{staticClass:"-general-main-layout"},[_vm._t("main")],2),_vm._v(" "),_c('div',{staticClass:"-general-footer-layout"},[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }